import { Drawer, Box, Typography, IconButton, ListItemSecondaryAction,Collapse} from '@mui/material'
import { useState,useEffect,useCallback } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { getDrawerList, getDrawerListNew } from '../../common/utility/configData'
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Settings from '@mui/icons-material/Settings';
import { ChevronLeft } from '@mui/icons-material';
import { getIndexOfRoute } from '../../common/utility/helperFunc';
import { ALLOWED_ROLES_PREMIUM, ALLOWED_ROLES_ELITE, TEXT_MSGS, USER_ROLE_FIELDS } from '../../common/utility/constant';
import { useAxios } from '../../common/api/hooks/useAxios';
import { URL } from '../../common/api/urls';
import { useNavigate} from 'react-router-dom';
import { Snackbar, Alert} from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { SNACKBAR_AUTO_HIDE_DURATION } from '../../common/utility/constant';
import DrawerContextMenu from './drawer_context_menu';
import useAuth from '../../common/hooks/useAuth';
// ============================================================
// NEW - Centralized Permission System
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from '../../common/hooks/usePermissions';
import LockIcon from '@mui/icons-material/Lock';
import RupeeIcon from '@mui/icons-material/CurrencyRupee';
import packageJson from '../../../package.json';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';


const KEY_NAME_ESC = 'Escape';
const KEY_EVENT_TYPE = 'keyup';


export const DrawerNestedMenu = (props) => {
  
  const routePath=window?.location?.pathname;
  const { auth } = useAuth();
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  
  // console.log("path================================>auth======================",window?.location?.pathname,window?.location,auth);
  const search=window?.location?.search;
  // ============================================================
  // OLD - Used deprecated getDrawerList(auth) (DEPRECATED)
  // Replaced by: getDrawerListNew(permissions)
  // See: src/common/utility/configData.js
  // ============================================================
  // const [drawerListData,setDrawerList]=useState(getDrawerList(auth))
  
  // NEW - Use centralized permission service
  const [drawerListData,setDrawerList]=useState(getDrawerListNew(permissions))
  const [selectedIndex, setSelectedIndex] = useState(getIndexOfRoute(routePath,search,auth));
  const [showContextMenu,setShowContextMenu]=useState(false);
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [url,setURL]=useState(undefined);

  const [collapsed, setCollapsed] =useState(true);
 
  const isExpandable = props.items && props.items.length > 0
  const [open, setOpen] = useState(props.selectedItem&&props.selectedItem.parentIndex==props.index&&props.selectedItem.sectionIndex==props.sectionIndex)

  function handleClick() {
    setOpen(!open)
  }
  
 const navigate = useNavigate();
 

  const exitMenu=()=>{
    setShowContextMenu(false);
   }
   

  

//   const handleListItemClick = (event, index) => {
//     const found = auth.role.some(r=> drawerListData[index].roles.indexOf(r) >= 0)
//     const resourceAllowed=drawerListData[index].resources==undefined?true:auth.resources?.some(r=> drawerListData[index].resources.indexOf(r) >= 0);
//     const isProNeeded = (ALLOWED_ROLES_PREMIUM === drawerListData[index].roles);
//     if(!found || !resourceAllowed){
//         console.log("Not allowed for the roles",auth.role,drawerListData[index].roles, isProNeeded)
//         //show modal
//         if(isProNeeded){
//           if(drawerListData[index].name=="Orderflow Charts" && auth.role.includes(USER_ROLE_FIELDS.PRO)){
//             console.log("OF drawer inside")
//             props.openSubscribeProModal(true,TEXT_MSGS.PREMIUM_PLUS_UPGRADE_ORDERFLOW_MSG);
//           }
//           else
//             props.openSubscribeProModal();
//         }
//         else
//           props.openSubscribeModal();
//         setIsDrawerOpen(false); 
//         return;
//     }
//     if(selectedIndex!==index){
//       console.log("drawer clicked event=",event)
//       if(event.ctrlKey ||event.metaKey){
//         window.open( `${process.env.REACT_APP_URL}${drawerListData[index].route.slice(1)}`, '_blank', 'noreferrer');
   
//       }
//     else
//     {
//       setSelectedIndex(index);
//       console.log("drawer pageview",window.location.pathname + window.location.search,drawerListData[index].route);
//       props.onChange(drawerListData[index].route,drawerListData[index].component);
//       setIsDrawerOpen(false);  
//     }
//   }
//   };

  

   //closes the context menu
  
useEffect(()=>{
    console.log("Nested menu selectedItem=",props.selectedItem,props.index)
},[])
  

  
  return (
    <>
   {/* onContextMenuClick */}
                    <ListItemButton
                      sx={{ py: 1,height: '30px !important', color: 'white', paddingRight:0 ,'&.MuiButtonBase-root': {
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        paddingLeft: '8px',
                        paddingRight: '0px',
                        minHeight: '30px',
                      }, }}
                    title={props.item.title?props.item.title:props.item.name}
                    onClick={()=>handleClick()}
                    selected={props.selectedItem.parentIndex==props.index && open==false && props.selectedItem.sectionIndex==props.sectionIndex}
                    >
        
                    <ListItemText
                      primary={props.item.name}
                      primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                    />

                    
                     {open ? 
                        <ListItemIcon sx={{ml:0,marginRight:"4px",minWidth:24, color:"#FFFFFF"}}>
                            <ExpandLess sx={{width:24}} />
                        </ListItemIcon>:
                        <ListItemIcon sx={{ml:0,marginRight:"4px",minWidth:24, color:"#FFFFFF"}}>
                            <ExpandMore sx={{width:24}} />
                        </ListItemIcon>
                    }

                    </ListItemButton>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      {props.item.items.map((nestedItem,nestedIndex) => (
                        <ListItemButton 
                        // sx={{ py: 1, minHeight: 40, color: 'white', paddingRight:0,marginLeft:"10px"  }} 
                        sx={{ 
                          py: 1,
                          height: '30px !important', 
                          color: 'white', 
                          paddingRight:0,
                          '&.MuiButtonBase-root': {
                          paddingTop: '2px',
                          paddingBottom: '2px',
                          paddingLeft: '8px',
                          paddingRight: '0px',
                          minHeight: '30px',
                          },
                        }}
                        selected={props.selectedItem.parentIndex==props.index &&props.selectedItem.sectionIndex==props.sectionIndex && props.selectedItem.childIndex==nestedIndex}
                        onContextMenu={(event)=>props.onContextMenuClick(event,nestedIndex,nestedItem)}
                        onClick={(event)=>props.onClick(event,nestedIndex,nestedItem,props.index,props.sectionIndex)}>
        
                        {/* Pulsing play icon indicator for new features */}
                        {nestedItem.isNew && (
                          <PlayArrowIcon
                            sx={{
                              fontSize: '16px',
                              color: '#667eea',
                              marginRight: '8px',
                              animation: 'pulsePlay 2s ease-in-out infinite',
                              filter: 'drop-shadow(0 0 4px rgba(102, 126, 234, 0.6))',
                              '@keyframes pulsePlay': {
                                '0%, 100%': {
                                  transform: 'scale(1)',
                                  opacity: 1,
                                },
                                '50%': {
                                  transform: 'scale(1.2)',
                                  opacity: 0.7,
                                },
                              },
                            }}
                          />
                        )}
                        <ListItemText
                          primary={nestedItem.name}
                          title={props.item.title?props.item.title:props.item.name}
                          primaryTypographyProps={{ fontSize: 14, paddingLeft:"20px", fontWeight: 'medium' }}
                        />
                        {/* NEW - Use centralized permission service with normalized roles */}
                        { !(nestedItem.roles ? permissions.hasAccess(nestedItem.roles, undefined) : true) || (nestedItem.resources!=undefined && !(Array.isArray(nestedItem.resources) ? permissions.hasAnyResource(nestedItem.resources) : permissions.hasResource(nestedItem.resources)))?
                    
                    ALLOWED_ROLES_ELITE == nestedItem.roles ?
                      <ListItemIcon sx={{ml:0,minWidth:24, color:"#DCB146"}}>
                        <LockIcon sx={{width:18}} />
                      </ListItemIcon>
                      :
                      <ListItemIcon sx={{ml:0,minWidth:24, color:"silver"}}>
                        <LockIcon sx={{width:18}} />
                      </ListItemIcon>
                    
                    : 
                    nestedItem.name=="Subscription Plans"? 
                      <ListItemIcon sx={{ml:0,minWidth:18}}>
                        <RupeeIcon sx={{width:18}} />
                      </ListItemIcon> : 
                    <></>
                }
                         
                        </ListItemButton>
                        ))}
                      </Collapse>


                    </>
 
  )
}
